import { useEffect } from "react";
import { getQueryObject } from "../index";
import PageUpdater from "../../containers/PageUpdater";
import { setCurrentMapId } from "../../store/mapStore/mapState";
import { setCurrentLocationIdByMapId } from "../../store/locationStore/locationState";
import { setCurrentFloorByMapId } from "../../store/floorStore/floorState";
import { GeneralRequest } from "../../requests/GeneralRequest";
import { requestAllDevicesByQuery } from "../../store/deviceStore/deviceRequests";
import FetchDeviceRequirementsWrapper from "../../containers/DevicesPage/FetchDeviceRequirementsWrapper";
import { ThreeColumnLayout } from "../../layouts/ThreeColumnLayout/ThreeColumnLayout";
import AnalysisCentralPanel from "../../containers/FrequencyAnalysisPage/AnalysisCentralPanel";
import AnalysisRightPanel from "../../containers/FrequencyAnalysisPage/AnalysisRightPanel";
import {
  requestAllTechnologyConfigurations
} from "../../store/technologyConfigurationStore/technologyConfigurationRequests";
import { clearFAData } from "../../store/freq-analysis/slice";
import { useTypedDispatch } from "../../app/state";

const LOCAL_STORAGE_KEY = 'FAPage';

function loadFromStorage() {
  return JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || '[]');
}

function saveDeviceIdListToStorage(idList: number[]) {
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(idList));
}

const FrequencyAnalysisPage = () => {
  const dispatch = useTypedDispatch();
  const urlProps = getQueryObject();
  const mapId = parseInt(urlProps.mapId as string);

  useEffect(() => {
    dispatch(clearFAData());
  }, []);

  const deviceIdList = loadFromStorage();

  return (
    <>
      <PageUpdater
        watchItemList={[
          {
            title: 'mapId',
            action: setCurrentMapId,
          },
          {
            title: 'mapId',
            action: setCurrentLocationIdByMapId,
          },
          {
            title: 'mapId',
            action: setCurrentFloorByMapId,
          },
        ]}
      />
      {
        isNaN(mapId) ? (
          <GeneralRequest
            requestAction={requestAllDevicesByQuery}
            requestArguments={[{ deviceIdList }]}
          >
            <FetchDeviceRequirementsWrapper>
              <GeneralRequest requestAction={requestAllTechnologyConfigurations}>
                <ThreeColumnLayout
                  centerMainPanel={<AnalysisCentralPanel />}
                  rightSideBar={<AnalysisRightPanel />}
                />
              </GeneralRequest>
            </FetchDeviceRequirementsWrapper>
          </GeneralRequest>
        ) : (
          <GeneralRequest
            requestAction={requestAllDevicesByQuery}
            requestArguments={[{ mapId }]}
          >
            <FetchDeviceRequirementsWrapper>
              <GeneralRequest requestAction={requestAllTechnologyConfigurations}>
                <ThreeColumnLayout
                  centerMainPanel={<AnalysisCentralPanel />}
                  rightSideBar={<AnalysisRightPanel />}
                />
              </GeneralRequest>
            </FetchDeviceRequirementsWrapper>
          </GeneralRequest>
        )
      }
    </>
  )
}

FrequencyAnalysisPage.saveDeviceIdListToStorage = saveDeviceIdListToStorage;
FrequencyAnalysisPage.loadFromStorage = loadFromStorage;

export default FrequencyAnalysisPage;